import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from 'components/Widget/WidgetLabel/constants';
import { TEXT_SHADOW_DEFAULT } from 'models/Widget/Widget';
import { DefaultWidgetPosition } from '../../PanelTemplatesTheme/constants';
import { PostSource, Sort } from '../../PanelTemplatesTheme/PanelTemplatesTheme';

export const HyperSpaceAlerts: Widget = {
    type: 'hyperSpaceAlerts',
    id: 'hyper-space-alerts',
    name: 'Alerts',
    useGlobalTimePeriod: true,
    postRequests: [
        {
            sources: [
                {
                    type: 'posts',
                    // Note: All global variables like reportingEngine, report, and filters
                    // are injected via PostRequest.getRequests()
                    id: new PostSource({
                        pageSize: 50,
                        sorts: [
                            new Sort({
                                order: 'DESC',
                                heading: {
                                    MONITORING_DASHBOARD: 'REACH_COUNT',
                                    LISTENING: 'REACH_COUNT',
                                    INBOUND_MESSAGE: 'INBOUND_COUNT',
                                    PLATFORM: 'TOTAL_ENGAGEMENT',
                                    BENCHMARKING: 'TOTAL_ENGAGEMENT',
                                    CAMPAIGN: 'OUTBOUND_STATUS',
                                    RDB_FIREHOSE: 'SN_CREATED_TIME',
                                },
                            }),
                        ],
                        timePeriod: {
                            key: 'last_7_days',
                        },
                        includeAlertPosts: true,
                    }) as any,
                    options: {
                        count: 200,
                        imagePreload: true,
                    },
                },
            ],
            format: {
                type: 'ordered',
                options: {
                    padding: 1,
                    fixedList: 0,
                },
            },
        },
    ],
    position: DefaultWidgetPosition,
    options: {
        player: {
            playing: true,
            duration: 6,
        },
        postVersion: 2,
        lineChart: {
            cumulative: true,
        },
        smartSize: {
            enabled: true,
            mode: 'responsive',
            size: 'm',
        },
    },
    label: {
        titleText: 'Alerts',
        enabled: false,
        size: WIDGET_LABEL_SIZE.primary,
        textShadow: TEXT_SHADOW_DEFAULT,
    },
};
